/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { types } from "mobx-state-tree"
import { QueryBuilder } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { ErrorParamsDtoModel, ErrorParamsDtoModelType } from "./ErrorParamsDtoModel"
import { ErrorParamsDtoModelSelector } from "./ErrorParamsDtoModel.base"
import { ScheduleActionIgnoredFeaturesDtoModel, ScheduleActionIgnoredFeaturesDtoModelType } from "./ScheduleActionIgnoredFeaturesDtoModel"
import { ScheduleActionIgnoredFeaturesDtoModelSelector } from "./ScheduleActionIgnoredFeaturesDtoModel.base"
import { RootStoreType } from "./index"


/**
 * ScheduleActionMetadataDtoBase
 * auto generated base class for the model ScheduleActionMetadataDtoModel.
 */
export const ScheduleActionMetadataDtoModelBase = ModelBase
  .named('ScheduleActionMetadataDto')
  .props({
    __typename: types.optional(types.literal("ScheduleActionMetadataDto"), "ScheduleActionMetadataDto"),
    scheduledOrdersCount: types.union(types.undefined, types.null, types.number),
    newScheduledOrdersCount: types.union(types.undefined, types.null, types.number),
    unscheduledOrdersCount: types.union(types.undefined, types.null, types.number),
    unscheduledDueToConstraintsMismatch: types.union(types.undefined, types.null, types.number),
    unscheduledDueToTagMismatch: types.union(types.undefined, types.null, types.number),
    unscheduledDueToTimeWindowShorterThanDuration: types.union(types.undefined, types.null, types.number),
    error: types.union(types.undefined, types.null, types.late((): any => ErrorParamsDtoModel)),
    ignored_features: types.union(types.undefined, types.null, types.late((): any => ScheduleActionIgnoredFeaturesDtoModel)),
    time_of_day_eta_applied: types.union(types.undefined, types.null, types.boolean),
    isScheduleAll: types.union(types.undefined, types.null, types.boolean),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class ScheduleActionMetadataDtoModelSelector extends QueryBuilder {
  get scheduledOrdersCount() { return this.__attr(`scheduledOrdersCount`) }
  get newScheduledOrdersCount() { return this.__attr(`newScheduledOrdersCount`) }
  get unscheduledOrdersCount() { return this.__attr(`unscheduledOrdersCount`) }
  get unscheduledDueToConstraintsMismatch() { return this.__attr(`unscheduledDueToConstraintsMismatch`) }
  get unscheduledDueToTagMismatch() { return this.__attr(`unscheduledDueToTagMismatch`) }
  get unscheduledDueToTimeWindowShorterThanDuration() { return this.__attr(`unscheduledDueToTimeWindowShorterThanDuration`) }
  get time_of_day_eta_applied() { return this.__attr(`time_of_day_eta_applied`) }
  get isScheduleAll() { return this.__attr(`isScheduleAll`) }
  error(builder: string | ErrorParamsDtoModelSelector | ((selector: ErrorParamsDtoModelSelector) => ErrorParamsDtoModelSelector) | undefined) { return this.__child(`error`, ErrorParamsDtoModelSelector, builder) }
  ignored_features(builder: string | ScheduleActionIgnoredFeaturesDtoModelSelector | ((selector: ScheduleActionIgnoredFeaturesDtoModelSelector) => ScheduleActionIgnoredFeaturesDtoModelSelector) | undefined) { return this.__child(`ignored_features`, ScheduleActionIgnoredFeaturesDtoModelSelector, builder) }
}
export function selectFromScheduleActionMetadataDto() {
  return new ScheduleActionMetadataDtoModelSelector()
}

export const scheduleActionMetadataDtoModelPrimitives = selectFromScheduleActionMetadataDto().scheduledOrdersCount.newScheduledOrdersCount.unscheduledOrdersCount.unscheduledDueToConstraintsMismatch.unscheduledDueToTagMismatch.unscheduledDueToTimeWindowShorterThanDuration.time_of_day_eta_applied.isScheduleAll
